import { computed as e, createBlock as t, createCommentVNode as n, createElementVNode as r, createTextVNode as i, createVNode as a, defineAsyncComponent as o, defineComponent as s, mergeModels as c, mergeProps as l, openBlock as u, toDisplayString as d, unref as f, useModel as p, withCtx as m } from "vue";
import { ROUTES as h, VuetifyValidationRules as g } from "@editor/ui-utils";
import { QInput as _, QItem as v, QItemSection as y, QSelect as b, QSeparator as x } from "quasar";
import { TAG_OPTIONS as S } from "@modules/news-article-utils";
import { useI18n as C } from "vue-i18n";
import { useEditorContent as w } from "@modules/news-article-editor-ui-components";
//#endregion
//#region src/lang/index.ts
var T = {
	en: {
		articles: {
			routeTitle: "Article",
			routeDetailTitle: "A: ",
			backToList: "Back to article list",
			settings: "Settings",
			content: "Content",
			preview: "Preview",
			basics: "Basics",
			saveKeepPublished: "Save & keep published",
			savePublish: "Publish",
			saveScheduled: "Schedule publication",
			saveRescheduled: "Save & schedule changes",
			scheduleChanges: "Schedule changes",
			publishAt: "Scheduled change date",
			saveOffline: "Unpublish",
			saveDraft: "Save as draft",
			deleteArticle: "Delete article",
			messagePublishTitle: "Publish article",
			messagePublish: "Are you sure you want to publish this article?",
			messageUnpublishTitle: "Unpublish article",
			invalidOperation: "Invalid operation",
			invalidOrigin: "This image comes from Xymatic and may not be used as a standalone image.",
			backToArticle: "Back to article",
			messageSaved: "Article saved",
			messageAutoImageTitle: "Automatically import images",
			messageAutoImage: "Shall the teaser image and other images be imported automatically?",
			messageAutoImageConfirm: "Yes, import",
			messageAutoImageCancel: "No",
			messageDeleteArticleTitle: "Delete article",
			messageDeleteArticle: "Are you sure you want to delete this article?",
			messageConfirmUnpublishArticle: "Are you sure you want to take the article offline?",
			messageConfirmDraftArticle: "Are you sure you want to set the article to draft?",
			messageRepublishInFuture: "Are you sure you want to unpublish the article and schedule it to be published in the future?",
			messageRepublishInFutureTitle: "Reschedule publishing",
			errorPreventSaveAsDraft: "The article cannot be saved as draft when a publish date is set. Please check the box \"Publish date\" or click \"Publish\".",
			errorMandatoryFields: "This article cannot be saved because mandatory information is missing.",
			errorPublishDateAfterSchedule: "The publish date cannot be after the scheduled change date.",
			errorScheduleDateLessThenNow: "The scheduled change date should be set in the future.",
			errorDisplayDateAfterSchedule: "The display date cannot be after the scheduled change date.",
			errorScheduleDateInPast: "The display date cannot be in the future.",
			errorUnpublishDateBeforeSchedule: "The unpublish date cannot be set before the scheduled change date.",
			errorUnpublishDateBeforeScheduleWithAlreadyUnpublishDate: "The scheduled change date cannot be after the unpublish date. Remove the unpublish date and save first - and then set the scheduled change.",
			errorAMPValidation1: "Article",
			errorAMPValidation2: "Was updated but the AMP validation failed",
			errorAssetLicense: "Asset publish is not permitted. Check asset brand license.",
			modeUnpublished: "Article unpublished",
			modeScheduled: "Publish date scheduled",
			modePublished: "Published",
			modeDraft: "Draft",
			removeArticle: "Show article",
			versions: "Versions",
			previewMobile: "Mobile",
			previewTablet: "Tablet",
			previewDesktop: "Desktop",
			migration: "Migration",
			hasAffiliateActivated: "This article has been marked as affiliate because it contains affiliate links.",
			noEditTooltip: "This article is originally from {source} editor.",
			addSelectedArticlesButton: "Add selected articles",
			addArticle: "Add article",
			tagTitle: "Tag title",
			cancelButton: "Cancel",
			updateShownDateCheckbox: "Update display date",
			updatePublishDateCheckbox: "Update publish date",
			handledInLegacySystem: "The article is being handled in {source} and cannot be edited in Vibe.",
			changedByUnknownAuthor: "Unknown author",
			changedByScheduledUpdate: "Scheduled changes",
			select: "Select article",
			cvdTagButton: "CVD tag",
			cvdTagLabel: "Select CVD tag",
			messageSavedCvdTag: "CVD tag saved",
			cvdTagNoneOption: "None",
			createVideoPage: "Create video page"
		},
		articlesSettings: {
			noIndexActivated: "NoIndex was activated",
			leadText: "Lead text",
			seoDescription: "Meta description",
			seoDescriptionEdited: "Meta description (edited)",
			peopleInArticle: "People within article",
			backgroundArticles: "Highlighted link",
			adArticle: "Mark as ad",
			adsEnabled: "Enable ads",
			isOutstreamEnabled: "Enable Outstream",
			withTableOfContents: "Show table of contents",
			withAffiliateBox: "Show affiliate box",
			showLiveBadge: "Live badge",
			commentsDisabled: "Disable comments",
			ampEnabled: "AMP enabled",
			hideFromNewsticker: "Hide in headline pages",
			hideFromTeaserList: "Hide in stages with newest articles",
			checkValidation: "Check validation",
			msn: "MSN Service",
			magazine: "Content from BUNTE-Magazin",
			adTags: "Ad tags",
			trackingTags: "Tracking tags",
			contextLabel: "Text label",
			contextLabelColor: "Label color",
			contextLabelColorDefault: "Default",
			contextLabelColorGreen: "Green",
			contextLabelPreview: "Preview",
			weight: "Weight",
			showPartnerLogo: "Show partner logo",
			isBought: "Article bought",
			seoUrlSettings: "URL & SEO",
			canonicalUrl: "Canonical URL",
			slug: "URL slug",
			pathConflictNotice: {
				template: "This path is in conflict with {pathType} path of another article. Only {pathRoutable} article will be reachable!",
				pathTypeCurrent: "the current",
				pathTypeOld: "an old",
				pathRoutableThis: "this",
				pathRoutableOther: "the other"
			},
			noIndex: "Activate noIndex",
			copyArticleUrl: "Copy article URL",
			copiedArticleUrl: "Article URL copied",
			copyArticleId: "Copy article ID",
			copiedArticleId: "Article ID copied",
			redirectActiveNotice: "This article has been redirected.",
			redirectMoreInfo: "(more info)",
			toArticle: "To article",
			author: "Author",
			createdBy: "Created by",
			messageAMPSuccess: "AMP validation successful",
			messageAMPFailed: "AMP validation failed",
			messageAMPFailedMandatory: "The AMP validation failed because not all mandatory fields are filled in.",
			messagePreviewTitle: "Article not saved",
			messagePreview: "Please save the article to see the changes in preview.",
			messagePreviewCancel: "Ok",
			messageNotSavedTitle: "Unsaved changes",
			messageNotSaved: "For opening the article and seeing the changes the article has to be saved first.",
			messageNotSavedCancel: "Back to editor",
			messageNotSavedButton: "Open anyway",
			bfJobTitle: "Job team",
			source: "Source",
			showMostReadArticles: "Show the most read articles block",
			general: "General",
			originalSourceUrl: "Curated URL",
			unpublishDateValidationMessage: "The unpublish date must not precede the publication date.",
			hasAdvertisementMarkTooltip: "Shows label \"Anzeige\"",
			commentsDisabledTooltip: "Only relevant for brands with user comments",
			publishDateBeforeConfirmationDialog: "The new publish date is before the the current publish date. Are you sure you want to set this date?",
			publishDateConfirmationDialog: "If you set a future publish date, the article will automatically be unpublished and republished at the desired time. If you want the article to remain published in its current form until the desired time, use the 'Save and schedule changes' button now. Are you sure you want to set a future publish date?",
			shownAfterPublicationDateValidationMessage: "The article is scheduled for publication. The display date must be the same as the publish date.",
			shownAfterCurrentDateValidationMessage: "The display date cannot be in the future.",
			shownBeforePublicationDateValidationMessage: "The display date may not be earlier than the publish date.",
			originalBrand: "Original brand",
			originalArticleUrl: "Original article URL",
			showCrossPublishFooter: "Show source attribution"
		},
		appearedOnHome: {
			iconConfirmed: "This article was manually placed on the homepage within the last {days} days.",
			iconUnknown: "This article has not been manually added to the homepage within the last {days} days.",
			lastPlaced: "Last placed: {date} ({via})",
			viaArticleList: "CvD list",
			viaNamed: "{kind} \"{name}\"",
			viaFixedArticle: "fixed article",
			checkButton: "Article on home",
			checkTooltip: "Runs a one-off check for whether this article was on the home page in the last {days} days.",
			lastCheck: "Last check: {date}",
			nextCheck: "Already checked - next check possible from {date}.",
			unavailable: "Analytics data is currently unavailable."
		},
		newsArticleList: {
			title: "Article",
			newButton: "New article",
			multiLabel: "Save selected articles",
			search: "Search for kicker, main headline or legacy ID",
			myArticles: "My articles",
			includeSubchannels: "Include subchannels",
			statusDropdown: "Status",
			statusAll: "All",
			statusDraft: "Draft",
			statusSchedule: "Scheduled",
			statusPublished: "Published",
			statusUnpublish: "Unpublished",
			typeDropdown: "Main media type",
			typeAll: "All",
			typeImages: "Image",
			typeVideos: "Video",
			typeGalleries: "Gallery",
			displayDateFrom: "Show from",
			displayDateTo: "Show to",
			displayPeriod: "Period (publish date)",
			isPremium: "Only Inside articles",
			isBought: "Article bought",
			contentPartner: "Content partner",
			loading: "Loading articles",
			deleteArticle: "Delete article",
			headerStatus: "Status",
			headerKickerTitle: "Kicker, main headline",
			headerChannel: "Channel",
			headerPublished: "Display date",
			headerChanged: "Last modified date",
			headerAMP: "AMP",
			headerBrand: "Brand",
			articleTypeFilter: "Article type",
			headerActions: "Actions",
			headerAMPDescription: "Green tick: The AMP version of the article is valid. It works on all Google platforms. Red Cross: The article contains elements that invalidate the AMP. Please check again.",
			multiSelect: "Select",
			dpEdit: "Edit",
			dpGoToArticle: "To article",
			duplicateArticle: "Duplicate",
			duplicateWithAissist: "Duplicate with Aissist",
			dpDelete: "Delete article",
			messageNoSelfLink: "An article cannot link to itself.",
			messageDelete1: "Are you sure you want to delete this article?",
			messageDelete2: "?",
			messageDeleteSuccess: "Article deleted",
			editNewTab: "Edit in new tab",
			scheduledChangeToolTipMessage: "Scheduled updates to this article are set for",
			authorshipType: "Author type",
			authorshipTypeAll: "All",
			authorshipTypeNewsArticle: "BF author",
			authorshipTypePartnerArticle: "Partner",
			authorshipTypeCrossPublishArticle: "Cross publication",
			authorshipTypeAgencyArticle: "Agency",
			authorshipTypeExpertsArticle: "Expert",
			excludeFeedsLabel: "Exclude feeds",
			excludeFeedsNone: "None",
			noTagFilterLabel: "All articles",
			pushArticle: "Push",
			trafficTarget: "Traffic target",
			trafficTargetAll: "All",
			trafficTargetDiscoverEvergreen: "Discover evergreen",
			trafficTargetSearchEvergreen: "SEO evergreen"
		},
		articlesEdit: {
			kicker: "Kicker (on Chip.de: sub-headline)",
			title: "Main headline",
			people: "People",
			leadText: "Lead text",
			words: "Words",
			chars: "Characters",
			addContent: "Add element",
			remove: "Remove",
			externalSource: "External source",
			excludedSources: "Excluded external sources",
			channel: "Channel",
			secondaryChannels: "Secondary channels",
			videosSecondaryChannelAdded: "{channelName} was added as a secondary channel.",
			articleTitle: "Article title",
			seoTitle: "SEO headline",
			articleType: "Article type",
			image: "Image",
			video: "Video",
			gallery: "Gallery",
			download: "Download",
			imageSelector: "Select or upload main image",
			mainImageTitle: "Main image",
			mainVideoTitle: "Main video",
			teaserVideoTitle: "Main video",
			teaserImageTitle: "Teaser image",
			mainImageTitleTooltip: "The main image is displayed on the article page.",
			mainVideoTitleTooltip: "The main video is displayed on the article page.",
			teaserVideoTitleTooltip: "The main video is displayed on the article page.",
			teaserImageTitleTooltip: "The teaser image is displayed on channel pages.",
			teaserImageSelector: "Select or upload teaser image",
			teaserInfo: "If no teaser image exists, the main image will be used on channel pages.",
			captionForArticle: "Caption only for this article",
			captionForArticleTooltip: "The field automatically contains the caption of the original image. However, it can be changed here for this article.",
			teaserInfoVideo: "If no teaser image exists the video image will be used on channel pages",
			gallerySelector: "Gallery image",
			teaserGalleryTitle: "Gallery images",
			teaserGalleryMainImageTitle: "Main image",
			teaserGalleryMainImageLabel: "Select or upload the main image",
			teaserGalleryMainImageCheckbox: "Add to gallery",
			teaserGalleryMainImageCheckboxTooltip: "The main image will be added to the selected gallery.",
			gallerySelectorTooltip: "The gallery image is displayed on the article page.",
			teaserDownloadTitle: "Download widget",
			teaserDownloadTitleTooltip: "The download widget is displayed on the article page.",
			teaserGalleryMainImageTitleTooltip: "The main image is optional.",
			teaserImageGallery: "Select or upload teaser image",
			dateSettingsTitle: "Publishing",
			showFirstPublishDate: "Show initial publish date",
			videoAutoplay: "Autoplay",
			articleDisplayDate: "Display date",
			noPublishDate: "Publish date",
			setPublishDate: "Publish date",
			setUnpublishDate: "Unpublish date",
			relatedDeleted: "Deleted",
			relatedExpired: "Depublished",
			relatedWeight: "Weight",
			relatedRemove: "Remove",
			relatedPlaceHere: "Place articles here",
			relatedPrioAd: "Ad",
			relatedPrioInside: "Login",
			relatedArticleAdd: "Link article",
			seoPerfect: "Perfect length",
			seoOkay: "Okay, shorten if possible",
			seoLong: "Too long, please shorten!",
			length: "Length",
			desktopAlertTitle: "An error has occurred.",
			desktopAlertDescription: "Your resolution is currently too low to display the desktop preview.<br/>Please minimize the menu on the left to display the desktop preview.",
			addPeople: "Add people",
			sourceTracking: "Customized tracking",
			communityTracking: "Community",
			seoDescriptionLabel: "Are you sure you want to change the meta description? This will no longer include future changes to the contents in the meta description automatically.",
			seoDescriptionConfirm: "Okay",
			seoDescriptionCancel: "Cancel",
			teaserDialogTitle: "Deactivate teaser texts",
			teaserDialogMsg: "Are you sure you want to deactivate the different teaser texts? This will lead to the texts not being used after saving the article.",
			teaserDialogConfirm: "Okay",
			teaserDialogCancel: "Cancel",
			teaserEnabled: "Teaser inputs created",
			updateShownDateCheckboxHint: "The display date gets updated automatically to the current timestamp when the article is saved or published.",
			updatePublishDateCheckboxHint: "Automatically updates the publish date to the selected scheduled change date.",
			linkTags: "Link tags",
			articlePushHistory: "Article push history",
			feedSettings: {
				title: "Feeds",
				description: "The article will be included in the following feeds. For MSN (DE) and Yahoo, articles set to Auto are included only when the article type is News and the other automatic rules apply.",
				options: {
					include: "Yes",
					exclude: "No",
					auto: "Automatic"
				}
			},
			internalNote: {
				title: "Internal note",
				placeholder: "Description (Internal)",
				tooltip: "This note field is internal only"
			},
			selectedPartnerImageWarning: "The selected partner image may only be used in the corresponding partner article.",
			selectedPartnerGalleryWarning: "The selected partner gallery may only be used in the corresponding partner article.",
			failedToLoadMainImage: "Error loading main image",
			articleTypeNews: "News",
			articleTypeArticle: "Product comparison",
			articleTypeTestReport: "Product test",
			articleTypeGuide: "Guide",
			articleTypeDownload: "Download"
		},
		articleBlocks: {
			ctaLayout: "Layout",
			ctaButton: "Button",
			ctaStickyButton: "Sticky button",
			ctaBox11: "Box 1:1",
			ctaBox11Info: "Box with image in 1:1 format",
			ctaBox169: "Box 16:9",
			ctaBox169Info: "Box with image in 16:9 format",
			ctaTitle: "Title",
			ctaButtonText: "Button text (max. 17 characters)",
			ctaLink: "Button link",
			ctaIsAffiliate: "Show affiliate disclaimer",
			noFollow: "No follow",
			noFollowTooltip: "The link will be labeled as \"nofollow\". Please always select nofollow for commercial links.",
			blockTeaser: "Article teaser",
			imageUrl: "Image URL",
			imagePlaceholder: "Link URL, must start with https://",
			captionForArticle: "Caption for this article only",
			captionForArticleTooltip: "The field automatically contains the caption of the original image. However, it can be changed here for this article.",
			hasAffiliate: "Affiliate Link",
			hasAffiliateTooltip: "If a link is labeled as an affiliate link, the affiliate disclaimer box will appear at the top of the article and the element will be marked as an advertisement.",
			newTab: "Open in new tab",
			hasFullSizeView: "Enable full size view",
			bound: "Bound",
			boundTooltip: "By default the banner appears standalone and not bound to the subsequent stage.",
			loginwallText: "Customers can register here to see more content. Logged in users don't see this element.",
			quoteAuthor: "Quote from",
			scriptBlock: "Insert custom JavaScript (will NOT be shown in AMP). Please be aware of the GDPR issues when used.",
			rawBlock: "Insert custom JavaScript (shown on AMP). Please be aware of the GDPR issues when used.",
			becomeInsider: "Become an INSIDER and continue reading.",
			highlightBox: "Higlight box",
			labelText: "Text field",
			labelImage: "Image",
			labelGallery: "Gallery",
			labelVideo: "Video",
			labelArticle: "Article",
			labelPaywall: "Paywall",
			labelLoginwall: "Login",
			labelSocial: "Social",
			labelQuote: "Quote",
			labelCTA: "Call to action",
			labelNewsletter: "Newsletter box",
			or: "OR",
			imageLink: "Alternatively add image via image link",
			imageUrlStart: "Image URL, must start with https://",
			imagePreview: "Preview"
		},
		articlesVersions: {
			noVersions: "No versions available",
			unknownEditor: "Editor unknown",
			modifiedBy: "Modified by",
			modifiedAt: "Last modified date"
		},
		articlesMigration: {
			directEditNotice: "Please note: The changes here take effect immediately and are independent of the save function!",
			source: "Source system",
			legacyId: "Legacy ID",
			renderedByCtf: "Rendered by CTF",
			editableInCtf: "Editable in Vibe",
			modifiedInCtf: "Modified in Vibe",
			confirmModal: {
				yes: "Yes",
				cancel: "Cancel",
				renderedBy: {
					title: "Changing toggle \"Rendered by CTF\"",
					message: "Are you sure you want to change the rendering system?"
				},
				editableIn: {
					title: "Changing toggle \"Editable in Vibe\"",
					message: "Are you sure you want to make the article editable in CTF? This cannot be undone!"
				}
			},
			viewCtfVersion: "View CTF version"
		},
		articleNotifications: {
			successfulMutation: {
				saved: "Article saved",
				deleted: "Deleted",
				published: "Published",
				unpublished: "Article unpublished",
				scheduled: "Scheduled",
				saveDraft: "Draft"
			},
			warnings: { empty: {
				image: "There is an empty \"image\" element that will be replaced with a placeholder.",
				twoImages: "There is an empty \"two images\" element that will be replaced with a placeholder.",
				video: "There is an empty \"video\" element that will be replaced with a placeholder.",
				text: "There is an empty \"text field\" element.",
				social: "There is an empty \"social block\" element that will be replaced with a placeholder.",
				gallery: "There is an empty \"gallery\" element that will be replaced with a placeholder.",
				chipWidget: "There is an empty \"CWC widget\" element that will be removed on saving.",
				cwcWidget: "There is an empty \"CWC widget\" element that will be removed on saving.",
				inpageWidget: "There is an empty \"inpage widget\" element that will be removed on saving.",
				backgroundArticle: "There is an empty \"highlighted link\" element that will be replaced with a placeholder."
			} },
			externalChange: {
				cleanReloaded: "This article was changed by another system. The latest server version has been loaded.",
				dirty: "This article was changed by another system, but you have unsaved changes. Save or discard your changes to load the latest version.",
				refetchFailed: "This article was changed externally, but the latest version could not be loaded. It may have been deleted or is temporarily unavailable."
			},
			staleEditorState: "This article was not saved, because the editor is showing content that belongs to a different article. Reload the page and make your changes again."
		},
		aissistDuplication: {
			title: "Duplicate with Aissist",
			aissistDuplicate: "Prompt selection",
			transform: "Transformation with Aissist",
			checkResult: "Result check",
			duplicateArticle: "Duplicate article",
			startAgain: "Start again",
			promptName: "Prompt name",
			prompt: "Prompt",
			promptLabels: {
				bunte: "Bunte.de",
				focus: "Focus.de",
				chip: "Chip.de",
				fitforfun: "FitForFun.de"
			},
			promptLabelsSolutions: {
				bunte: "Bunte.de (Solutions)",
				focus: "Focus.de (Solutions)",
				chip: "Chip.de (Solutions)",
				fitforfun: "FitForFun.de (Solutions)"
			},
			processFormat: "Process article in format",
			html: "HTML",
			markdown: "Markdown",
			original: "Original",
			aissistOutput: "Aissist output",
			kicker: "Kicker",
			leadText: "Lead text",
			content: "Content",
			loadingMessage: "Transforming article with AISSIST...",
			contentToSend: "Content to be sent to Aissist",
			rawResponse: "Raw AISSIST Response",
			extractedText: "Extracted text for parsing",
			promptNotFound: "No prompt template found for this brand",
			transformError: "Failed to transform article with Aissist. Please try again.",
			transformTimeout: "Aissist duplication timed out. The service may be busy. Please try again later.",
			transformFailed: "Aissist duplication failed. Please try again or contact support.",
			duplicateError: "Failed to duplicate article"
		},
		articlePartner: {
			partnerTabTitle: "Partner settings",
			partner: "Partner",
			assemblerUuid: "Assembler article ID",
			isBought: "Article bought",
			isNotBilled: "Article is not billed",
			boughtDate: "Bought date",
			partnerCanonicalUrl: "Partner canonical URL",
			isNoIndexBought: "NoIndex when bought",
			unpublishBoughtAfterDays: "Unpublish after days (when bought)",
			authors: "Authors",
			partnerArticleLinks: "Partner article links",
			partnerArticleMetadata: "Partner article metadata",
			changeArticleAuthorshipTypeLabel: "Change to standard article",
			changeArticleAuthorshipTypeTitle: "Warning: Changing article authorship",
			changeArticleAuthorshipTypeDialogMessage: "Switching from partner article to article (type news) will permanently remove all partner associations, including tracking tags and the original article reference block. Please review the article and manually remove any remaining partner references. This action cannot be undone."
		},
		abHeadlineTest: {
			startLink: "Start A/B headline test",
			viewHistory: "View A/B headline test history",
			cancelButton: "Cancel",
			stopButton: "Stop test",
			viewTestButton: "View test",
			viewHistoryButton: "A/B headline test history",
			runningMessage: "An A/B test is already running for the main headline on teaser level.",
			pendingMessage: "An A/B test is pending and will start once the article is published.",
			testCompletedBanner: "A/B headline test completed",
			viewResults: "View results",
			scheduleDisabledByTest: "The changes cannot be scheduled while an A/B test is active.",
			testDisabledBySchedule: "The A/B test cannot be started while changes are scheduled.",
			saveBeforeTestTitle: "Unsaved changes",
			saveBeforeTestMessage: "There are unsaved changes. The article must be saved before starting an A/B test.",
			saveBeforeTestConfirm: "Save & continue"
		}
	},
	de: {
		articles: {
			routeTitle: "Artikel",
			routeDetailTitle: "A: ",
			backToList: "Zurück zur Artikelliste",
			settings: "Einstellungen",
			content: "Inhalt",
			preview: "Vorschau",
			basics: "Basics",
			saveKeepPublished: "Speichern & veröffentlicht lassen",
			savePublish: "Veröffentlichen",
			saveScheduled: "Veröffentlichung planen",
			saveOffline: "Depublizieren",
			saveRescheduled: "Speichern & Änderungen planen",
			publishAt: "Geplantes Veröffenlichungsdatum",
			scheduleChanges: "Änderungen planen",
			saveDraft: "Als Entwurf speichern",
			messageSaved: "Artikel gespeichert",
			deleteArticle: "Artikel löschen",
			messagePublishTitle: "Artikel veröffentlichen",
			messagePublish: "Bist du sicher, dass du den Artikel veröffentlichen möchtest?",
			messageUnpublishTitle: "Artikel depublizieren",
			invalidOperation: "Ungültiger Vorgang",
			invalidOrigin: "Dieses Bild kommt von Xymatic and darf nicht als Standalone-Bild verwendet werden.",
			backToArticle: "Zurück zum Artikel",
			messageAutoImageTitle: "Bilder automatisch importieren",
			messageAutoImage: "Sollen das Teaser-Bild und weitere Bilder automatisch importiert werden?",
			messageAutoImageConfirm: "Ja, importieren",
			messageAutoImageCancel: "Nein",
			messageDeleteArticleTitle: "Artikel löschen",
			messageDeleteArticle: "Bist du dir sicher, dass du den Artikel löschen möchtest?",
			messageConfirmUnpublishArticle: "Bist du sicher, dass du den Artikel offline nehmen möchtest?",
			messageConfirmDraftArticle: "Bist du sicher, dass du den Artikel als entwurf speichern möchtest?",
			messageRepublishInFuture: "Willst du den Artikel wirklich depublizieren und eine spätere Wiederveröffentlichung planen?",
			messageRepublishInFutureTitle: "Veröffentlichung neu planen",
			errorPreventSaveAsDraft: "Der Artikel kann nicht als Entwurf gespeichert werden, wenn ein Veröffentlichungsdatum (publish date) festgelegt ist. Bitte die Box \"Kein Veröffentlichungsdatum\" anhaken oder auf \"Veröffentlichen\" klicken.",
			errorMandatoryFields: "Der Artikel kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			errorPublishDateAfterSchedule: "Das Veröffentlichungsdatum darf nicht nach dem Geplanten Änderungsdatum liegen.",
			errorDisplayDateAfterSchedule: "Das Anzeigedatum (display date) darf nicht nach dem Geplanten Änderungsdatum liegen.",
			errorScheduleDateLessThenNow: "Das Geplante Änderungsdatum sollte in der Zukunft liegen.",
			errorScheduleDateInPast: "Das Anzeigedatum (display date) darf nicht in der Zukunft liegen.",
			errorUnpublishDateBeforeSchedule: "Das Ablaufdatum darf nicht vor dem Geplanten Änderungsdatum liegen.",
			errorUnpublishDateBeforeScheduleWithAlreadyUnpublishDate: "Das geplante Änderungsdatum kann nicht nach dem Ablaufdatum liegen. Bitte erst das Ablaufdatum löschen und den Inhalt speichern - und dann die Änderungen planen.",
			errorAMPValidation1: "Artikel ",
			errorAMPValidation2: "Wurde aktualisiert, aber die AMP-Validierung ist fehlgeschlagen.",
			errorAssetLicense: "Die Veröffentlichung von Assets ist nicht erlaubt. Bitte Lizenz der Asset-Marke prüfen.",
			modeUnpublished: "Artikel depubliziert",
			modeScheduled: "Veröffentlichung geplant",
			modePublished: "Veröffentlicht",
			modeDraft: "Entwurf",
			removeArticle: "Artikel anzeigen",
			versions: "Versionen",
			previewMobile: "Mobile",
			previewTablet: "Tablet",
			previewDesktop: "Desktop",
			migration: "Migration",
			hasAffiliateActivated: "Dieser Artikel wurde als Affiliateartikel markiert, da er Affiliatelinks enthält.",
			noEditTooltip: "Dieser Artikel stammt ursprünglich vom {source}-Editor.",
			addSelectedArticlesButton: "Ausgewählte Artikel hinzufügen",
			addArticle: "Artikel hinzufügen",
			tagTitle: "Tag-Titel",
			cancelButton: "Abbrechen",
			updateShownDateCheckbox: "Anzeigedatum (display date) aktualisieren",
			updatePublishDateCheckbox: "Veröffentlichungsdatum (publish date) aktualisieren",
			handledInLegacySystem: "Dieser Artikel wird in {source} verwaltet und kann nicht in Vibe bearbeitet werden.",
			changedByUnknownAuthor: "Unbekannter Autor",
			changedByScheduledUpdate: "Geplante Änderungen",
			select: "Artikel auswählen",
			cvdTagButton: "CVD-Tag",
			cvdTagLabel: "CVD-Tag auswählen",
			messageSavedCvdTag: "CVD-Tag gespeichert",
			cvdTagNoneOption: "Keine",
			createVideoPage: "Videoseite erstellen"
		},
		articlesSettings: {
			noIndexActivated: "NoIndex wurde aktiviert",
			leadText: "Vorspann",
			seoDescription: "Meta Description",
			seoDescriptionEdited: "Meta Description (geändert)",
			peopleInArticle: "Personen im Artikel",
			backgroundArticles: "Hervorgehobener Link",
			adArticle: "Als Anzeige markieren",
			adsEnabled: "Werbung aktivieren",
			isOutstreamEnabled: "Outstream aktiveren",
			withTableOfContents: "Inhaltsverzeichnis anzeigen",
			withAffiliateBox: "Affiliate-Box anzeigen",
			showLiveBadge: "Live-Badge",
			commentsDisabled: "Kommentare deaktivieren",
			ampEnabled: "AMP aktiviert",
			hideFromNewsticker: "Nicht auf Schlagzeilen-Seite anzeigen",
			hideFromTeaserList: "Nicht in Stages mit neuesten Artikeln zeigen",
			checkValidation: "Validierung prüfen",
			msn: "MSN-Service",
			magazine: "Inhalt aus dem BUNTE-Magazin",
			adTags: "Werbe-Tags",
			trackingTags: "Tracking-Tags",
			contextLabel: "Text-Label",
			contextLabelColor: "Label-Farbe",
			contextLabelColorDefault: "Standard",
			contextLabelColorGreen: "Grün",
			contextLabelPreview: "Vorschau",
			weight: "Wichtigkeit",
			showPartnerLogo: "Partner-Logo anzeigen",
			isBought: "Artikel gekauft",
			seoUrlSettings: "URL & SEO",
			canonicalUrl: "Canonical URL",
			slug: "URL-Slug",
			pathConflictNotice: {
				template: "Dieser Pfad überschneidet sich mit {pathType} Pfad eines anderen Artikels. Nur {pathRoutable} Artikel ist erreichbar!",
				pathTypeCurrent: "dem aktuellen",
				pathTypeOld: "einem alten",
				pathRoutableThis: "dieser",
				pathRoutableOther: "der andere"
			},
			noIndex: "NoIndex aktivieren",
			copyArticleUrl: "Artikel-URL kopieren",
			copiedArticleUrl: "Artikel-URL kopiert",
			copyArticleId: "Artikel-ID kopieren",
			copiedArticleId: "Artikel-ID kopiert",
			redirectActiveNotice: "Für diesen Artikel wurde ein Redirect eingerichtet.",
			redirectMoreInfo: "(mehr Info)",
			toArticle: "Zum Artikel",
			author: "Autor",
			createdBy: "Erstellt von",
			messageAMPSuccess: "AMP-Validierung erfolgreich",
			messageAMPFailed: "AMP-Validierung fehlgeschlagen",
			messageAMPFailedMandatory: "Die AMP-Validierung ist fehlgeschlagen, weil Pflichtinformationen fehlen.",
			messagePreviewTitle: "Artikel nicht gespeichert",
			messagePreview: "Bitte speichern, um die Änderungen in der Preview zu sehen.",
			messagePreviewCancel: "Ok",
			messageNotSavedTitle: "Nicht gespeicherte Änderungen",
			messageNotSaved: "Um den Artikel zu öffnen und die Änderungen zu sehen, muss er erst gespeichert werden.",
			messageNotSavedCancel: "Zurück zum Editor",
			messageNotSavedButton: "Trotzdem öffnen",
			bfJobTitle: "Jobteam",
			source: "Quelle",
			showMostReadArticles: "Zeige die Meistgelesen-Stage",
			general: "Allgemein",
			originalSourceUrl: "Kuratierte URL",
			unpublishDateValidationMessage: "Das Ablaufdatum darf nicht vor dem Veröffentlichungsdatum (publish date) liegen.",
			hasAdvertisementMarkTooltip: "Als Anzeige markieren",
			commentsDisabledTooltip: "Nur relevant für Marken mit User-Kommentaren",
			publishDateBeforeConfirmationDialog: "Das neue Veröffentlichungsdatum (publish date) liegt vor dem aktuellen Veröffentlichungsdatum (publish date). Willst du das wirklich so festlegen?",
			publishDateConfirmationDialog: "Wird das Veröffentlichungsdatum (publish date) in die Zukunft gesetzt, wird der Artikel automatisch depubliziert und zum gewünschten Zeitpunkt erneut veröffentlicht. Soll der Artikel bis zum gewünschten Zeitpunkt in unveränderter Form online bleiben, den Button \"Speichern und Änderungen planen\" nutzen. Soll das Veröffentlichungsdatum (publish date) wirklich in die Zukunft gesetzt werden?",
			shownAfterPublicationDateValidationMessage: "Der Artikel ist zur Veröffentlichung geplant. Das Anzeigedatum (display date) muss dasselbe sein wie das Veröffentlichungsdatum (publish date).",
			shownAfterCurrentDateValidationMessage: "Das Anzeigedatum (display date) darf nicht in der Zukunft liegen.",
			shownBeforePublicationDateValidationMessage: "Das Anzeigedatum (display date) darf nicht vor dem Veröffentlichungsdatum (publish date) liegen.",
			originalBrand: "Originalmarke",
			originalArticleUrl: "URL des Originalartikels",
			showCrossPublishFooter: "Quellenhinweis anzeigen"
		},
		appearedOnHome: {
			iconConfirmed: "Dieser Artikel wurde in den letzten {days} Tagen manuell auf der Startseite platziert.",
			iconUnknown: "Dieser Artikel wurde in den letzten {days} Tagen nicht manuell auf der Startseite platziert.",
			lastPlaced: "Zuletzt platziert: {date} ({via})",
			viaArticleList: "CvD-Liste",
			viaNamed: "{kind} „{name}“",
			viaFixedArticle: "fixierter Artikel",
			checkButton: "Artikel auf der Home",
			checkTooltip: "Prüft einmalig, ob dieser Artikel in den letzten {days} Tagen auf der Startseite war.",
			lastCheck: "Letzte Prüfung: {date}",
			nextCheck: "Bereits geprüft – erneute Prüfung ab {date} möglich.",
			unavailable: "Analysedaten sind derzeit nicht verfügbar."
		},
		newsArticleList: {
			title: "Artikel",
			newButton: "Neuer Artikel",
			multiLabel: "Ausgewählte Artikel speichern",
			search: "Suchen nach Hauptzeile, Vorzeile oder Legacy-ID",
			myArticles: "Meine Artikel",
			includeSubchannels: "Sub-Channels einbeziehen",
			statusDropdown: "Status",
			statusAll: "Alle",
			statusDraft: "Entwurf",
			statusSchedule: "Geplant",
			statusPublished: "Veröffentlicht",
			statusUnpublish: "Depubliziert",
			typeDropdown: "Haupt-Medientyp",
			typeAll: "Alle",
			typeImages: "Bild",
			typeVideos: "Video",
			typeGalleries: "Galerie",
			displayDateFrom: "Zeige von",
			displayDateTo: "Zeige bis",
			displayPeriod: "Zeitraum (Veröffentlichungsdatum)",
			isPremium: "Nur Premiumartikel",
			isBought: "Artikel gekauft",
			contentPartner: "Content-Partner",
			loading: "Lade Artikel",
			deleteArticle: "Artikel löschen",
			headerStatus: "Status",
			headerKickerTitle: "Vorzeile, Hauptzeile",
			headerChannel: "Channel",
			headerPublished: "Anzeigedatum (display date)",
			headerChanged: "Änderungsdatum (last modified)",
			headerAMP: "AMP",
			headerBrand: "Marke",
			articleTypeFilter: "Artikeltyp",
			headerActions: "Aktionen",
			headerAMPDescription: "Grüner Haken: Die AMP-Version des Artikels ist gültig. Damit funktioniert er auf allen Google-Plattformen. Rotes Kreuz: Der Artikel enthält Elemente, welche die AMP ungültig machen. Bitte nochmals prüfen.",
			multiSelect: "Auswählen",
			dpEdit: "Bearbeiten",
			dpGoToArticle: "Zum Artikel",
			duplicateArticle: "Duplizieren",
			duplicateWithAissist: "Mit Aissist duplizieren",
			dpDelete: "Artikel löschen",
			messageNoSelfLink: "Ein Artikel kann nicht auf sich selbst verlinken.",
			messageDelete1: "Willst du diesen Artikel wirklich löschen?",
			messageDelete2: "löschen willst?",
			messageDeleteSuccess: "Artikel gelöscht",
			editNewTab: "In neuem Tab bearbeiten",
			scheduledChangeToolTipMessage: "Geplante Änderungen dieses Artikels sind geplant für",
			authorshipType: "Autoren-Typ",
			authorshipTypeAll: "Alle",
			authorshipTypeNewsArticle: "BF-Autor",
			authorshipTypePartnerArticle: "Partner",
			authorshipTypeCrossPublishArticle: "Cross-Publikation",
			authorshipTypeAgencyArticle: "Agentur",
			authorshipTypeExpertsArticle: "Experte",
			excludeFeedsLabel: "Feeds ausschließen",
			excludeFeedsNone: "Keine",
			noTagFilterLabel: "Alle Artikel",
			pushArticle: "Pushen",
			trafficTarget: "Traffic-Ziel",
			trafficTargetAll: "Alle",
			trafficTargetDiscoverEvergreen: "Discover-Evergreen",
			trafficTargetSearchEvergreen: "SEO-Evergreen"
		},
		articlesEdit: {
			kicker: "Vorzeile (auf Chip.de: Unterzeile)",
			title: "Hauptzeile",
			people: "Personen",
			leadText: "Vorspann",
			words: "Wörter",
			chars: "Zeichen",
			addContent: "Element hinzufügen",
			remove: "Entfernen",
			externalSource: "Externe Quelle",
			excludedSources: "Ausgeschlossene externe Quelle",
			channel: "Channel",
			secondaryChannels: "Sekundäre Channels",
			videosSecondaryChannelAdded: "{channelName} wurde als Sekundärer Channel hinzugefügt.",
			articleTitle: "Artikel-Titel",
			seoTitle: "SEO-Überschrift",
			articleType: "Artikel-Typ",
			image: "Bild",
			video: "Video",
			gallery: "Galerie",
			download: "Download",
			imageSelector: "Hauptbild auswählen oder hochladen",
			mainImageTitle: "Hauptbild",
			mainVideoTitle: "Hauptvideo",
			teaserVideoTitle: "Hauptvideo",
			teaserImageTitle: "Teaserbild",
			mainImageTitleTooltip: "Das Hauptbild wird auf der Artikelseite angezeigt.",
			mainVideoTitleTooltip: "Das Hauptbild wird auf der Artikelseite angezeigt.",
			teaserVideoTitleTooltip: "Das Hauptvideo wird auf der Artikelseite angezeigt.",
			teaserImageTitleTooltip: "Das Teaserbild wird auf Channelseiten angezeigt.",
			teaserImageSelector: "Teaserbild auswählen oder hochladen",
			teaserInfo: "Wenn kein Teaserbild vorhanden ist, wird das Hauptbild auf Channelseiten benutzt.",
			captionForArticle: "Bildunterschrift nur für diesen Artikel",
			captionForArticleTooltip: "Das Feld enthält zunächst automatisch die Bildunterschrift des Originalbildes. Die Bildunterschrift lässt sich aber hier für diesen Artikel ändern.",
			teaserInfoVideo: "Wenn kein Teaserbild vorhanden ist, wird das Videobild auf Channelseiten benutzt",
			gallerySelector: "Galerie-Bild",
			teaserGalleryTitle: "Galeriebilder",
			teaserGalleryMainImageTitle: "Hauptbild",
			teaserGalleryMainImageLabel: "Hauptbild auswählen oder hochladen",
			teaserGalleryMainImageCheckbox: "Zur Galerie hinzufügen",
			teaserGalleryMainImageCheckboxTooltip: "Das Hauptbild wird der gewählten Galerie hinzugefügt.",
			gallerySelectorTooltip: "Das Galerie-Bild wird auf der Artikelseite angezeigt.",
			teaserDownloadTitle: "Download-Widget",
			teaserDownloadTitleTooltip: "Das Download-Widget wird auf der Artikelseite angezeigt.",
			teaserGalleryMainImageTitleTooltip: "Das Hauptbild ist optional.",
			teaserImageGallery: "Teaserbild auswählen oder hochladen",
			dateSettingsTitle: "Veröffentlichung",
			showFirstPublishDate: "Erstveröffentlichungsdatum anzeigen",
			videoAutoplay: "Autoplay",
			articleDisplayDate: "Anzeigedatum (display date)",
			noPublishDate: "Veröffentlichungsdatum (publish date)",
			setPublishDate: "Veröffentlichungsdatum (publish date)",
			setUnpublishDate: "Ablaufdatum",
			relatedDeleted: "Gelöscht",
			relatedExpired: "Depubliziert",
			relatedWeight: "Wichtigkeit",
			relatedRemove: "Entfernen",
			relatedPlaceHere: "Artikel hier platzieren",
			relatedPrioAd: "Ad",
			relatedPrioInside: "Login",
			relatedArticleAdd: "Artikel verlinken",
			seoPerfect: "Perfekte Länge",
			seoOkay: "Okay, kürzen, wenn möglich",
			seoLong: "Zu lang, bitte kürzen!",
			length: "Länge",
			desktopAlertTitle: "Es ist ein Fehler aufgetreten.",
			desktopAlertDescription: "Deine Auflösung ist aktuell zu gering, um die Desktop-Vorschau anzuzeigen. Bitte minimiere das Menü auf der linken Seite, um das Anzeigen zu ermöglichen.",
			addPeople: "Personen verlinken",
			sourceTracking: "Benutzerdefiniertes Tracking",
			communityTracking: "Community",
			seoDescriptionLabel: "Willst du die Meta Description wirklich ändern? Dann werden künftige Änderungen der Inhalte nicht mehr automatisch in die Meta Description übernommen.",
			seoDescriptionConfirm: "Okay",
			seoDescriptionCancel: "Abbrechen",
			teaserDialogTitle: "Teaser-Texte deaktivieren",
			teaserDialogMsg: "Willst du wirklich die unterschiedlichen Teaser-Texte deaktivieren? Dann werden die Texte nach dem Speichern des Artikels nicht mehr verwendet.",
			teaserDialogConfirm: "Okay",
			teaserDialogCancel: "Abbrechen",
			teaserEnabled: "Eingabefelder für Teaser erstellt",
			updateShownDateCheckboxHint: "Das Anzeigedatum (display date) wird beim Speichern oder Veröffentlichen automatisch aktualisiert.",
			updatePublishDateCheckboxHint: "Aktualisiert das Veröffentlichungsdatum (publish date) automatisch auf das Geplante Änderungsdatum.",
			linkTags: "Tags verlinken",
			articlePushHistory: "Push/Eil-History",
			feedSettings: {
				title: "Feeds",
				description: "Der Artikel erscheint in folgenden Feeds:",
				options: {
					include: "Ja",
					exclude: "Nein",
					auto: "Automatisch"
				}
			},
			internalNote: {
				title: "Interne Notiz",
				placeholder: "Beschreibung (intern)",
				tooltip: "Dieses Notizfeld ist nur für den internen Gebrauch bestimmt"
			},
			selectedPartnerImageWarning: "Das ausgewählte Partner-Bild darf nur in dem entsprechenden Partner-Artikel verwendet werden.",
			selectedPartnerGalleryWarning: "Die ausgewählte Partner-Galerie darf nur im entsprechenden Partner-Artikel verwendet werden.",
			failedToLoadMainImage: "Hauptbild konnte nicht geladen werden",
			articleTypeNews: "News",
			articleTypeArticle: "Produktvergleich",
			articleTypeTestReport: "Produkttest",
			articleTypeGuide: "Ratgeber",
			articleTypeDownload: "Download"
		},
		articleBlocks: {
			ctaLayout: "Layout",
			ctaButton: "Button",
			ctaStickyButton: "Sticky button",
			ctaBox11: "Box 1:1",
			ctaBox11Info: "Box mit Bild im 1:1 Format",
			ctaBox169: "Box 16:9",
			ctaBox169Info: "Box mit Bild im 16:9 Format",
			ctaTitle: "Titel",
			ctaButtonText: "Button -Text (max. 17 Zeichen)",
			ctaLink: "Button-Link",
			ctaIsAffiliate: "Zeige Affiliate-Disclaimer",
			noFollow: "No Follow",
			noFollowTooltip: "Der Link wird als \"nofollow\" gekennzeichnet. Bitte für werbliche Links immer nofollow auswählen.",
			blockTeaser: "Artikel-Teaser",
			imageUrl: "Bild-URL",
			imagePlaceholder: "Link-URL einfügen (muss mit https:// beginnen)",
			captionForArticle: "Bildunterschrift nur für diesen Artikel",
			captionForArticleTooltip: "Das Feld enthält zunächst automatisch die Bildunterschrift des Originalbildes. Die Bildunterschrift lässt sich aber hier für diesen Artikel ändern.",
			hasAffiliate: "Affiliate-Link",
			hasAffiliateTooltip: "Ist ein Link als Affiliate-Link gekennzeichnet, erscheint am Anfang des Artikels die Affiliate-Disclaimer-Box und das Element wird als Anzeige markiert.",
			newTab: "In neuem Tab öffnen",
			hasFullSizeView: "Ansicht in Originalgröße ermöglichen",
			bound: "Bündig",
			boundTooltip: "Standardmäßig steht das Banner einzeln mit Abstand zur nachfolgenden Stage.",
			becomeInsider: "INSIDER werden und direkt weiterlesen.",
			loginwallText: "Nutzer können sich hier registrieren um mehr Inhalte zu sehen. Eingeloggten Benutzern wird dieses Element nicht angezeigt.",
			quoteAuthor: "Zitat von",
			scriptBlock: "Benutzerdefiniertes JavaScript einfügen (wird nicht auf AMP angezeigt). Bitte Auswirkungen auf DSGVO beachten.",
			rawBlock: "Benutzerdefiniertes JavaScript einfügen (wird auf AMP angezeigt). Bitte Auswirkungen auf DSGVO beachten.",
			highlightBox: "Highlight-Box",
			labelText: "Textfeld",
			labelImage: "Bild",
			labelGallery: "Galerie",
			labelVideo: "Video",
			labelArticle: "Artikel",
			labelPaywall: "Paywall",
			labelLoginwall: "Login",
			labelSocial: "Social",
			labelQuote: "Zitat",
			labelCTA: "Call-to-action",
			labelNewsletter: "Newsletter-Box",
			or: "ODER",
			imageLink: "Alternativ Bild per Link einfügen",
			imageUrlStart: "Bild-URL (muss mit https:// beginnen)",
			imagePreview: "Vorschau"
		},
		articlesVersions: {
			noVersions: "Keine Version verfügbar",
			unknownEditor: "Unbekannter Autor",
			modifiedBy: "Geändert von",
			modifiedAt: "Änderungsdatum (last modified)"
		},
		articlesMigration: {
			directEditNotice: "Bitte beachten: Die hier sichtbaren Änderungen werden sofort wirksam und sind unabhängig von der Speichern-Funktion!",
			source: "Ursprüngliches System",
			legacyId: "Legacy ID",
			renderedByCtf: "Gerendert durch CTF",
			editableInCtf: "Bearbeitung in Vibe",
			modifiedInCtf: "Geändert in Vibe",
			confirmModal: {
				yes: "Ja",
				cancel: "Abbrechen",
				renderedBy: {
					title: "Toggle \"Rendering durch CTF\" ändern",
					message: "Willst du das Rendering-System wirklich ändern?"
				},
				editableIn: {
					title: "Toggle \"Bearbeitung in Vibe\" ändern",
					message: "Willst du für diesen Artikel wirklich die Bearbeitung in Vibe erlauben? Das kann nicht rückgängig gemacht werden!"
				}
			},
			viewCtfVersion: "CTF-Version ansehen"
		},
		articleNotifications: {
			successfulMutation: {
				saved: "Artikel gespeichert",
				deleted: "Gelöscht",
				published: "Veröffentlicht",
				unpublished: "Artikel depubliziert",
				scheduled: "Geplant",
				saveDraft: "Entwurf"
			},
			warnings: { empty: {
				image: "Es gibt ein leeres \"Bild\"-Element,das durch einen Platzhalter ersetzt wird.",
				twoImages: "Es gibt ein leeres \"Zwei Bilder\"-Element, das durch einen Platzhalter ersetzt wird.",
				video: "Es gibt ein leeres \"Video\"-Element, das durch einen Platzhalter ersetzt wird.",
				text: "Es gibt ein leeres \"Textfeld\"-Element.",
				social: "Es gibt ein leeres \"Social\"-Element, das durch einen Platzhalter ersetzt wird.",
				gallery: "Es gibt ein leeres \"Galerie\"-Element, das durch einen Platzhalter ersetzt wird.",
				chipWidget: "Es gibt ein leeres \"CWC-Widget\"-Element, das beim Speichern entfernt wird.",
				cwcWidget: "Es gibt ein leeres \"CWC-Widget\"-Element, das beim Speichern entfernt wird.",
				inpageWidget: "Es gibt ein leeres \"Inpage-Widget\"-Element, das beim Speichern entfernt wird.",
				backgroundArticle: "Es gibt ein leeres \"Hervorgehobener Link\"-Element, das durch einen Platzhalter ersetzt wird."
			} },
			externalChange: {
				cleanReloaded: "Dieser Artikel wurde von einem anderen System geändert. Die aktuelle Serverversion wurde geladen.",
				dirty: "Dieser Artikel wurde von einem anderen System geändert, aber es gibt ungespeicherte Änderungen. Speichere oder verwirf deine Änderungen, um die neueste Version zu laden.",
				refetchFailed: "Dieser Artikel wurde extern geändert, aber die aktuelle Version konnte nicht geladen werden. Er wurde möglicherweise gelöscht oder ist vorübergehend nicht verfügbar."
			},
			staleEditorState: "Dieser Artikel wurde nicht gespeichert, weil der Editor Inhalte eines anderen Artikels anzeigt. Lade die Seite neu und nimm deine Änderungen erneut vor."
		},
		aissistDuplication: {
			title: "Mit Aissist duplizieren",
			aissistDuplicate: "Prompt-Auswahl",
			transform: "Transformation mit Aissist",
			checkResult: "Ergebnisprüfung",
			duplicateArticle: "Artikel duplizieren",
			startAgain: "Neu beginnen",
			promptName: "Prompt-Name",
			prompt: "Prompt",
			promptLabels: {
				bunte: "Bunte.de",
				focus: "Focus.de",
				chip: "Chip.de",
				fitforfun: "FitForFun.de"
			},
			promptLabelsSolutions: {
				bunte: "Bunte.de (Solutions)",
				focus: "Focus.de (Solutions)",
				chip: "Chip.de (Solutions)",
				fitforfun: "FitForFun.de (Solutions)"
			},
			processFormat: "Artikel verarbeiten im Format",
			html: "HTML",
			markdown: "Markdown",
			original: "Original",
			aissistOutput: "Aissist-Ergebnis",
			kicker: "Vorzeile",
			leadText: "Vorspann",
			content: "Inhalt",
			loadingMessage: "Artikel wird mit AISSIST transformiert...",
			contentToSend: "Inhalt, der an Aissist gesendet wird",
			rawResponse: "Rohe AISSIST-Antwort",
			extractedText: "Extrahierter Text für Parsing",
			promptNotFound: "Kein Prompt-Template für diese Marke gefunden",
			transformError: "Artikel konnte nicht mit Aissist transformiert werden. Bitte erneut versuchen.",
			transformTimeout: "Das Aissist-Duplizieren hat das Zeitlimit überschritten. Der Dienst ist möglicherweise ausgelastet. Bitte später erneut versuchen.",
			transformFailed: "Aissist-Duplizierung fehlgeschlagen. Bitte erneut versuchen oder Support kontaktieren.",
			duplicateError: "Artikel konnte nicht dupliziert werden"
		},
		articlePartner: {
			partnerTabTitle: "Partner-Einstellungen",
			partner: "Partner",
			assemblerUuid: "Assembler-Artikel-ID",
			isBought: "Artikel gekauft",
			isNotBilled: "Artikel wird nicht abgerechnet",
			boughtDate: "Kaufdatum",
			partnerCanonicalUrl: "Partner-Canonical-URL",
			isNoIndexBought: "NoIndex beim Kauf",
			unpublishBoughtAfterDays: "Tage bis zu Depublizieren nach dem Kauf",
			authors: "Autoren",
			partnerArticleLinks: "Partnerartikel-Links",
			partnerArticleMetadata: "Partnerartikel-Metadaten",
			changeArticleAuthorshipTypeLabel: "In Standard-Artikel ändern",
			changeArticleAuthorshipTypeTitle: "Warnung: Änderung der Urheberschaft eines Artikels",
			changeArticleAuthorshipTypeDialogMessage: "Durch das Ändern von Partner-Artikel auf Artikel (Typ News) werden alle Partnerverknüpfungen dauerhaft entfernt, einschließlich der Tracking-Tags und des ursprünglichen Artikelverweisblocks. Bitte überprüfe den Artikel und entferne alle verbleibenden Partnerverweise manuell. Diese Aktion kann nicht rückgängig gemacht werden."
		},
		abHeadlineTest: {
			startLink: "A/B-Headline-Test starten",
			viewHistory: "A/B-Headline-Test-Verlauf anzeigen",
			cancelButton: "Abbrechen",
			stopButton: "Test stoppen",
			viewTestButton: "Test anzeigen",
			viewHistoryButton: "A/B-Headline-Test-Verlauf",
			runningMessage: "Ein A/B-Test läuft bereits für die Hauptzeile auf Teaser-Level.",
			pendingMessage: "Ein A/B-Test steht aus und startet, sobald der Artikel veröffentlicht wird.",
			testCompletedBanner: "A/B-Headline-Test abgeschlossen",
			viewResults: "Ergebnisse anzeigen",
			scheduleDisabledByTest: "Die Änderungen können nicht geplant werden, während ein A/B-Test aktiv ist.",
			testDisabledBySchedule: "Der A/B-Test kann nicht gestartet werden, während Änderungen geplant sind.",
			saveBeforeTestTitle: "Nicht gespeicherte Änderungen",
			saveBeforeTestMessage: "Es gibt nicht gespeicherte Änderungen. Der Artikel muss gespeichert werden, bevor ein A/B-Test gestartet werden kann.",
			saveBeforeTestConfirm: "Speichern & fortfahren"
		}
	}
}, E = [{
	path: `/${h.articles.path}`,
	meta: { i18RouteTitleKey: h.articles.path },
	children: [
		{
			path: "",
			name: "content_list",
			component: () => import("./content-list-kC_yQZar.js"),
			meta: { requiredRight: "articles:navigate" },
			props: (e) => ({ source: e.query.source })
		},
		{
			path: "new",
			name: "content_new",
			component: () => import("./content-edit-BVb0yXWB.js"),
			props: (e) => ({
				id: void 0,
				tab: e.query.tab,
				backRoute: "/articles"
			}),
			meta: { requiredRight: "articles:navigate" }
		},
		{
			path: ":id",
			name: "content_edit",
			component: () => import("./content-edit-BVb0yXWB.js"),
			props: (e) => ({
				id: e.params.id,
				tab: e.query.tab,
				backRoute: "/articles"
			}),
			meta: { requiredRight: "articles:navigate" }
		}
	]
}], D = { class: "no-wrap" }, O = /* @__PURE__ */ s({
	__name: "content-tags-dropdown.selector",
	props: /* @__PURE__ */ c({
		noTagFilterLabel: { default: "newsArticleList.noTagFilterLabel" },
		disable: {
			type: Boolean,
			default: !1
		},
		stateOptions: { default: () => [] }
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: /* @__PURE__ */ c(["change:tag", "click:already-selected-tag"], ["update:modelValue"]),
	setup(o, { emit: s }) {
		let { t: c } = C(), h = o, g = p(o, "modelValue"), _ = s;
		function w(e) {
			g.value === e && _("click:already-selected-tag");
		}
		let T = e(() => [
			{
				label: c(h.noTagFilterLabel),
				value: ""
			},
			...h.stateOptions,
			...S.map((e) => ({
				label: e.title,
				value: e.id
			}))
		]), E = (e) => h.stateOptions.length > 0 && e === h.stateOptions[0]?.value, O = (e) => h.stateOptions.length > 0 && e === h.stateOptions[h.stateOptions.length - 1]?.value;
		return (e, s) => (u(), t(f(b), {
			modelValue: g.value,
			"onUpdate:modelValue": [s[0] ||= (e) => g.value = e, s[1] ||= (e) => _("change:tag", g.value)],
			"data-qa-content-tag-dropdown": g.value,
			options: T.value,
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			"dropdown-icon": "expand_more",
			outlined: "",
			disable: o.disable
		}, {
			"selected-item": m((e) => [r("div", D, d(e.opt.label), 1)]),
			option: m((e) => [
				E(e.opt.value) ? (u(), t(f(x), { key: 0 })) : n("", !0),
				a(f(v), l(e.itemProps, {
					"data-qa-content-tag-dropdown-option": e.opt.value,
					onClick: (t) => w(e.opt.value)
				}), {
					default: m(() => [a(f(y), null, {
						default: m(() => [i(d(e.opt.label), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1040, ["data-qa-content-tag-dropdown-option", "onClick"]),
				O(e.opt.value) ? (u(), t(f(x), { key: 1 })) : n("", !0)
			]),
			_: 1
		}, 8, [
			"modelValue",
			"data-qa-content-tag-dropdown",
			"options",
			"disable"
		]));
	}
}), k = /* @__PURE__ */ s({
	__name: "table-of-contents-input",
	props: /* @__PURE__ */ c({ locked: {
		type: Boolean,
		default: !1
	} }, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(r) {
		let { t: i } = C(), a = w(), o = e(() => !!a.content.hasTableOfContents), s = p(r, "modelValue");
		return (e, a) => o.value ? (u(), t(f(_), l({ key: 0 }, e.$attrs, {
			modelValue: s.value,
			"onUpdate:modelValue": a[0] ||= (e) => s.value = e,
			dense: "",
			outlined: "",
			type: "text",
			label: f(i)("common.tableOfContentsText"),
			rules: [f(g).maxLength(100)],
			disable: r.locked,
			readonly: r.locked,
			class: "q-mb-md",
			"hide-bottom-space": "",
			"data-qa-article-content-text-block-table-of-contents-input": ""
		}), null, 16, [
			"modelValue",
			"label",
			"rules",
			"disable",
			"readonly"
		])) : n("", !0);
	}
}), A = o(() => import("./content-edit-BVb0yXWB.js")), j = o(() => import("./content-list-kC_yQZar.js")), M = o(() => import("./contents-list-selector-yMHn13R9.js")), N = o(() => import("./content-list-selector-Ce7_82KC.js")), P = {
	messages: T,
	routes: E,
	contentBlocks: []
};
//#endregion
export { A as ContentEdit, j as ContentList, N as ContentListSelector, O as ContentTagsSelector, M as ContentsListSelector, k as TableOfContentsInput, P as contentModule };

//# sourceMappingURL=index.es.js.map